import { render, staticRenderFns } from "./DriverApp.vue?vue&type=template&id=37719286&"
import script from "./DriverApp.vue?vue&type=script&lang=js&"
export * from "./DriverApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports